import {
  type DatabaseEntry,
  type DatabaseField,
  DatabaseFieldType,
  type DatabaseValue
} from '@databases/types/database';

const generateValue = (fieldType: DatabaseFieldType, index: number) => {
  if (fieldType === DatabaseFieldType.TEXT) {
    return { plain: `text ${index}` };
  } else if (fieldType === DatabaseFieldType.USER) {
    return [
      {
        _id: `user-${index}`,
        accountId: `user-${index}`,
        displayName: `User ${index}`
      }
    ];
  } else if (fieldType === DatabaseFieldType.HYPERLINK) {
    return [
      {
        url: 'https://test.com'
      },
      {
        url: 'https://test.com'
      }
    ];
  }
};

/**
 * Fills in the values for a database. Right now it only fills in Text, User, and Hyperlink fields.
 */
export const generateValuesForEntriesById = (
  entryIds: string[],
  fields: DatabaseField[]
) => {
  const result: Record<string, DatabaseEntry> = {};

  let valueIndex = 0;
  for (const entryId of entryIds) {
    result[entryId] = {
      id: entryId,
      values: Object.fromEntries(
        fields
          .filter(
            (f) =>
              f.type === DatabaseFieldType.TEXT ||
              f.type === DatabaseFieldType.USER ||
              f.type === DatabaseFieldType.HYPERLINK
          )
          .map((field) => {
            const result = [
              field.id,
              {
                type: field.type,
                value: generateValue(field.type, valueIndex)
              }
            ];
            valueIndex += 1;
            return result;
          })
      ) as Record<string, DatabaseValue<DatabaseFieldType, object>>
    };
  }

  return result;
};
